import { faDownload, faInfoCircle, faRemove } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import FileSaver from "file-saver";
import moment from "moment";
import { FC, useState, useEffect } from "react";
import { useDropzone } from 'react-dropzone';
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { DownloadUtil } from "src/framework/commons/DownloadUtil";
import { FullWidthButton } from "src/framework/components/buttons/FullWidthButton";
import { LinearProgressBar } from "src/framework/components/commons/LinearProgressBar";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { apiNoLoading, IDataRequest, STATUS_CODE } from "src/framework/providers/api";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { distribuidores$, resolveProtocolUrl, resolveUploadUrl, revendas$ } from "src/store/global.store";
import theme from "src/theme/light";
import { Anexo } from "./types";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { notifierStore } from "src/framework/store/NotifierStore";

const projetosProvider = new ProjetosProvider();

export const download = (url: string, nomeArquivo: string): void => {
    if (url !== "") {

        FileSaver.saveAs(url, `${nomeArquivo}`)
    }
};

export interface RowAnexoProperties {
    index: number;
    anexo: Anexo;
    disabled?: boolean;
    descricoes: DescricoesValidate;
    onRemove: (index: number) => void;
}
const parseSituacao = (anexo: Anexo, descricoes: DescricoesValidate) => {
    const keys = Object.keys(anexo)
    if (keys.includes("@remove")) {
        return <span style={{ color: theme.palette.error.main }}>Remover</span>
    }

    if (!!anexo.created_at) {
        return <span style={{ color: theme.palette.grey[500] }}>Ok</span>
    }

    if (descricoes.old.includes(String(anexo.descricao)) && (!keys.includes("created_at"))) {
        return <span style={{ color: theme.palette.error.main }}>Descrição duplicada</span>
    }

    return <span style={{ color: theme.palette.warning.main }}>Pendente</span>
}

const RowAnexo: FC<RowAnexoProperties> = ({
    index,
    anexo,
    disabled = false,
    onRemove,
    descricoes,
}) => {
    const uploadUrl = LocalStorage.get("solar.uploadInfo", true);
    return <>
        <TableRow>
            <TableCell>{index}</TableCell>
            <TableCell>
                {anexo.descricao}
            </TableCell>
            <TableCell>{parseSituacao(anexo, descricoes)}</TableCell>
            <TableCell align="right" colSpan={2}>
                {anexo?.created_at === null || anexo?.created_at === undefined ? "" :
                    <>
                        <IconButton size="small" style={{ color: theme.palette.secondary.main }}
                            onClick={() => {
                                if (!!anexo?.created_at) {
                                    download(resolveProtocolUrl(`//${resolveUploadUrl(uploadUrl ? uploadUrl : LocalStorage.get("solar.uploadInfo", true))}${anexo?.url}`), String(anexo.url?.split("/").pop()))
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faDownload} size="xs" fixedWidth />
                        </IconButton>
                        &nbsp;&nbsp;&nbsp;
                    </>
                }
                <IconButton size="small" style={{ color: theme.palette.error.main }} disabled={disabled} onClick={() => {
                    onRemove(index);
                }}>
                    <FontAwesomeIcon icon={faRemove} size="xs" fixedWidth />
                </IconButton>
            </TableCell>
        </TableRow>
    </>
}

type UploadFileProperties = {
    anexo: AnexoFile,
    index: number;
    nomesAnexos: string[];
    disabled?: boolean;
    onRemove: (index: number) => void;
    hasError: (error: boolean, index: number) => void;
    onChange: (descricao: string, index: number) => void;

}

const UploadFile: FC<UploadFileProperties> = ({
    anexo,
    nomesAnexos = [],
    index,
    disabled = false,
    onRemove,
    onChange,
    hasError,
}) => {

    const _anexo: AnexoFile = anexo;

    const [error, setError] = useState<boolean>(false)

    const isUnique = (value: string): boolean => {
        let _error: boolean = false;
        for (let n of nomesAnexos) {
            const _nome: string[] = n.split(":")
            if (_nome[0] !== String(anexo.index) && _nome[1] === value) {
                _error = true
            }
        }
        hasError(_error, index)
        return _error;
    }

    return <>
        <TableRow>

            <TableCell padding="checkbox">{index + 1}</TableCell>
            <TableCell>
                {_anexo.previewName}
                <Tooltip title={String(_anexo.file?.name)}>
                    <span style={{ cursor: "help", marginLeft: "7px" }}>
                        <FontAwesomeIcon icon={faInfoCircle} color={theme.palette.grey[400]} />
                    </span>
                </Tooltip>
            </TableCell>
            <TableCell align="right">{Formater.toString((Number(_anexo?.file?.size || 0) / 1024), TypeRecords.DECIMAL2) + " Kb"}</TableCell>
            <TableCell>
                <InputText
                    margin="none"
                    fullWidth
                    value={_anexo?.descricao}
                    error={error}
                    disabled={disabled}
                    onChange={(event: any) => {
                        onChange(event.target.value, index)
                        setError(isUnique(event.target.value))
                    }}
                    onBlur={(event: any) => {
                        setError(isUnique(event.target.value))
                    }}

                // label="Descrição"
                />
            </TableCell>
            <TableCell width={120}>
                {_anexo.progress ? _anexo.progress > 99.9 ? "Ok" : <><LinearProgressBar progress={_anexo.progress} /></> : "Pendente"}
            </TableCell>
            <TableCell align="right">
                <IconButton size="small" style={{ color: theme.palette.error.main }} onClick={() => onRemove(index)} disabled={disabled}>
                    <FontAwesomeIcon icon={faRemove} size="sm" />
                </IconButton>
            </TableCell>
        </TableRow>
    </>
}

export interface AnexosVerticaisProperties {
    formState: any;
    anexos?: Anexo[];
    disabled?: boolean;
    onChange: (uploads: any) => void
    onRemove: (uploads: any) => void
    onCapturaCodigoVenda: (codigoVenda: string) => void
}

export type AnexoFile = {
    index?: number;
    descricao?: string;
    file?: File;
    previewName?: string | null;
    progress?: number
}
type DescricoesValidate = {
    old: string[],
    new: string[],
}
const AnexosVerticais: FC<AnexosVerticaisProperties> = ({
    formState,
    anexos = [],
    disabled = false,
    onChange,
    onRemove,
    onCapturaCodigoVenda,
}) => {
    const [listAnexos, setListaAnexos] = useState<Anexo[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [uploading, setUploading] = useState<boolean>(false);
    const [hasError, setHasError] = useState<number[]>([]);

    const [anexosFileList, setAnexosList] = useState<AnexoFile[]>([])
    const [descricoes, setDescricoes] = useState<DescricoesValidate>({
        new: [],
        old: [],
    })
    const { getRootProps, getInputProps } = useDropzone({
        disabled: disabled,
        onDropAccepted: (_files) => {
            const _anexoList: AnexoFile[] = [];
            let count: number = 1;
            for (let file of _files) {
                const now: string = moment().format("YYYYMMDDHHmmss");
                const descricao = String(file.name || "").split('.').slice(0, -1).join('.');

                _anexoList.push({
                    index: count - 1,
                    file: file,
                    previewName: `ARQ-[CODIGO_PROJETO]-${now}-${count++}`,
                    descricao,
                })
            }
            setAnexosList(_anexoList);
        }
    });

    useEffect(() => {
        if (anexos.length > 0) {
        }
    }, []);

    useEffect(() => {
        if (anexos.length > 0) {
        }
    }, [formState.distribuidor_id, formState.distribuidor]);

    useEffect(() => {
        if (anexos.length > 0) {
            descricoes.old = anexos.filter((a) => !!a?.created_at).map((a) => String(a.descricao))
            setDescricoes(descricoes);
            setListaAnexos(anexos);
        } else {
            setListaAnexos([]);
        }
    }, [anexos]);

    const isValid = (): boolean => {
        if (anexosFileList.length > 0 && !anexosFileList.map((a) => a?.descricao || "").includes("")) {
            return false
        }
        return true;
    }

    const doDownload = async (): Promise<void> => {
        const response = await projetosProvider.downloadAnexos(formState.id);
        if (response?.statusCode === STATUS_CODE.OK && response?.data) {
            DownloadUtil.zip(response.data, formState.codigo_venda + "-Anexos");
        } else {
            if (response?.message) {
                notifierStore.setNotifier({
                    title: "Aviso!!!",
                    content: response?.message,
                    timeOut: 3000,
                    onClose: () => {
                        notifierStore.setOpen(false);
                    }
                });
                notifierStore.setOpen(true);
            }
        }
    }

    const upload = async (): Promise<void> => {
        const result: any = {}
        try {
            setUploading(true)
            let codigoProjeto = formState?.codigo_venda || "";
            if (codigoProjeto === "") {

                let cpfCnpj = formState.distribuidor?.cnpj_cpf

                if (cpfCnpj === undefined) {
                    const distribuidores = distribuidores$.getValue()?.data || []

                    const idxDistribuidor = distribuidores.findIndex((d) => {
                        return d.id === formState.distribuidor_id
                    })

                    if (idxDistribuidor > -1) {
                        formState.distribuidor = distribuidores[idxDistribuidor]
                        cpfCnpj = formState.distribuidor?.cnpj_cpf;
                    }

                    if (formState.revenda_id) {
                        const revendas = revendas$.getValue()?.data || []

                        const idxRevenda = revendas.findIndex((r) => {
                            return r.id === formState.revenda_id;
                        })

                        if (idxRevenda > -1) {
                            formState.revenda = revendas[idxRevenda];
                            cpfCnpj = formState.revenda?.cnpj_cpf
                        }
                    }
                }

                if (cpfCnpj) {
                    const captura = await projetosProvider.capturar({
                        cpfCnpjDistribuidor: formState.distribuidor?.cnpj_cpf,
                        tipo: formState.tipo,
                        segmento: 'vertical_ongrid', 
                        engenharia: true,
                        codigo_venda: formState?.codigo_venda,
                    });
                    codigoProjeto = captura.codigo_venda;
                    onCapturaCodigoVenda(codigoProjeto)
                } else {
                    notifierStore.setNotifier({
                        title: "Aviso!!!",
                        content: `CPF/CNPJ do distribuidor ${formState.distribuidor}`,
                        timeOut: 3000,
                        onClose: () => {
                            notifierStore.setOpen(false);
                        }
                    })
                    notifierStore.setOpen(true);
                }

            }
            const url: string = `/projetos/anexos/${codigoProjeto}`;
            const requestList: IDataRequest[] = [];

            for (let idxAnexo in anexosFileList) {
                const form = new FormData();
                if (anexosFileList[idxAnexo]?.file !== undefined) {
                    const _file: any = anexosFileList[idxAnexo];
                    const extension: string = _file.file.name.split(".").pop();
                    const filename = `${anexosFileList[idxAnexo].previewName?.replace("[CODIGO_PROJETO]", codigoProjeto)}.${extension}`;
                    form.append(filename, _file.file, _file.file.name);
                    result[`${filename}`] = { success: {}, error: {}, descricao: anexosFileList[idxAnexo].descricao }

                    const request: IDataRequest = {
                        url: url,
                        data: form,
                        onUploadProgress: (progressEvent: any) => {
                            const progress: number = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            anexosFileList[idxAnexo].progress = progress
                            setAnexosList([...anexosFileList])
                        }
                    }

                    requestList.push(request)
                }
            }

            const responses = await Promise.all([...requestList.map((r) => {
                return apiNoLoading.post(r)
            })])

            const keys = Object.keys(result);

            for (let response of responses) {
                const responseKey = Object.keys(response.data).shift();
                result[String(responseKey)].success = response.data[String(responseKey)]
            }


            onChange(keys.map((idx) => {
                return {
                    url: result[idx].success.path,
                    descricao: result[idx].descricao
                }
            }))

            setAnexosList([])

        } catch (error) {

        } finally {
            setUploading(false)
            setOpenDialog(false)
        }
    }

    return <>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell width={20} >#</TableCell>
                    <TableCell>
                        Descricao
                    </TableCell>
                    <TableCell>Situação</TableCell>
                    <TableCell width={200} >
                        <FullWidthButton
                            disabled={disabled || (!formState?.distribuidor?.id && !formState?.distribuidor_id)}
                            text="Adicionar anexo"
                            variant="outlined"
                            onClick={() => {
                                setOpenDialog(true)
                            }}
                        />
                    </TableCell>
                    <TableCell width={220} >
                        <FullWidthButton
                            disabled={!formState?.id || !listAnexos?.length}
                            text="Download anexo(s)"
                            variant="outlined"
                            onClick={() => {
                                doDownload()
                            }}
                        />
                    </TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {listAnexos.map((anexo: Anexo, index: number) => {
                    const key = `verticais-anexos-${formState.codigo_venda}-${anexo.id}`
                    return <RowAnexo
                        index={index + 1}
                        key={"verticais-anexos-row" + key}
                        anexo={anexo}
                        descricoes={descricoes}
                        onRemove={(idx) => {
                            if (listAnexos.length > 0 && !!listAnexos[idx - 1].created_at) {
                                listAnexos[idx - 1]["@remove"] = true;
                            } else {
                                listAnexos.splice(idx - 1, 1)
                            }
                            setListaAnexos([...listAnexos])
                            onRemove(listAnexos)
                        }}
                    />
                })}
            </TableBody>
        </Table>

        <Dialog open={openDialog} maxWidth="xl" style={{ minWidth: "1024px" }}>
            <DialogTitle id="verticais-upload-dialog-title">Carregar arquivos</DialogTitle>
            <DialogContent style={{ padding: "5px" }}>
                <DialogContentText >
                    <div className="row">
                        <div className="X12">

                            <section className="container">
                                <div {...getRootProps({ className: 'dropzone' })} style={{
                                    display: "flex",
                                    height: "100px",
                                    color: `${theme.palette.grey[500]}`,
                                    border: `dotted 2px ${theme.palette.grey[500]}`,
                                    background: `${theme.palette.grey[300]}`,
                                    borderRadius: theme.shape.borderRadius,
                                    textAlign: "center",
                                    alignContent: "center",
                                    alignItems: "center",
                                    justifyItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <input {...getInputProps()} accept=".pdf" />
                                    <p style={{ padding: "0px 15px" }}>Arraste e solte um ou mais arquivos aqui, ou clique para selecionar</p>
                                </div>
                                {anexosFileList.length <= 0 ? "" : <>
                                    <aside>
                                        <h4>Arquivo</h4>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell padding="checkbox">#</TableCell>
                                                    <TableCell>Arquivo</TableCell>
                                                    <TableCell align="right">Tamanho</TableCell>
                                                    <TableCell>Descricao<sup style={{ color: theme.palette.error.light }}>*</sup></TableCell>
                                                    <TableCell>Situação</TableCell>
                                                    <TableCell align="right">
                                                        <Tooltip title={"Remover todos"}>
                                                            <IconButton size="small" style={{ color: theme.palette.error.main }} onClick={() => setAnexosList([])}>
                                                                <FontAwesomeIcon icon={faRemove} size="sm" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {anexosFileList.map((anexo: any, index: number) => {
                                                    const nomesAnexos: any = (anexosFileList?.map((a) => `${a.index}:${a?.descricao}`))

                                                    return <UploadFile
                                                        key={`verticais-pre-upload-file-${formState.codigo_venda}-${index}`}
                                                        anexo={anexo}
                                                        index={index}
                                                        nomesAnexos={nomesAnexos}
                                                        disabled={uploading}
                                                        onRemove={(index) => {
                                                            anexosFileList.splice(index, 1)
                                                            setAnexosList([...anexosFileList])
                                                        }}
                                                        onChange={(descricao, index) => {
                                                            anexosFileList[index].descricao = descricao
                                                            setAnexosList([...anexosFileList])
                                                        }}
                                                        hasError={(_error, _index) => {
                                                            const errorState: number[] = [...hasError]

                                                            if (_error) {
                                                                errorState.push(index);
                                                                setHasError(errorState)
                                                            } else {
                                                                setHasError(errorState.filter((n) => n !== _index))
                                                            }

                                                        }}
                                                    />
                                                })}
                                            </TableBody>
                                        </Table>
                                    </aside>
                                </>}
                            </section>
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={uploading}
                    onClick={() => {
                        setOpenDialog(false);
                        setAnexosList([]);
                    }}
                    color="secondary">
                    Cancelar
                </Button>
                <Button
                    onClick={() => {
                        upload().then(() => {
                            // setOpenDialog(false)
                        })
                    }}
                    disabled={isValid() || uploading || hasError.length > 0}
                    color="primary" variant="contained" disableElevation>
                    {uploading ? <><CircularProgress variant="indeterminate" size={20} /></> : "Carregar"}
                </Button>
            </DialogActions>
        </Dialog>
    </>
}

export { AnexosVerticais }